import { cioanalytics } from "@/Plugins/customerio.js";
import { eventBus } from "@/Helpers/eventbus.js";
import { resetScrollRegionsErrorCount } from "@/Helpers/inertiaErrorHandler.js";

let trackedUrl = null;

export const trackPageView = () => {
    eventBus.clearFlash();
    resetScrollRegionsErrorCount();

    if (trackedUrl === window.location.href) return;

    trackedUrl = window.location.href;
    cioanalytics.page();
};
